const $ = jQuery.noConflict();

'use strict';
const MoveElements = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	/** @description Initialize */
	init: function() {
		this.moveElem();
	},
	moveElem: function() {
		// login form popup elements
		$('.site-header__login-inner .login-password').append($('.js-move-icon'));
		$('.site-header__login-inner .login-submit').append($('.js-login-submit-button-text'));
	}
};

export default MoveElements;
